import * as Sentry from '@sentry/react'
import { useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'

import {
  analyticsPageview,
  stopReplayOnTokenRoute,
} from 'lib/oneTimeTokenPrivacy'
import { isPostHogEnabled, posthog } from 'lib/posthog'

// posthog.init sets `capture_pageview: false`, so SPA route changes would
// otherwise go unrecorded. This router subscription is the app's only source
// of PostHog page views.
export const useTracking = () => {
  const router = useRouter()

  useEffect(() => {
    const unsubscribe = router.subscribe('onResolved', (event) => {
      // Runs whether or not PostHog is enabled: Sentry replay is independent.
      stopReplayOnTokenRoute(event.toLocation.pathname, Sentry.getReplay)
      if (!isPostHogEnabled()) return

      // Redacted: /reset/<token> and /magic/<token> carry a live credential.
      const page = analyticsPageview(
        event.toLocation.pathname,
        event.toLocation.searchStr,
        window.location.href,
      )
      posthog.capture('$pageview', {
        $current_url: page.href,
        path: page.path,
      })
    })

    return unsubscribe
  }, [router])
}
